import { navigateTo, useRoute, useRuntimeConfig } from "#imports";
import { safelyNavigateTo } from "@malt/utils";
import { getCurrentServerName } from "../internals/serverUtils.js";
function stripTrailingSlash(path) {
  return path.replace(/\/$/, "");
}
export function redirectToSignIn(redirect) {
  const route = useRoute();
  const config = useRuntimeConfig();
  const currentHost = getCurrentServerName();
  const currentRoute = `${stripTrailingSlash(config.app.baseURL)}${route.fullPath}`;
  const query = { redirect: route.name === "Signin" ? void 0 : redirect || currentRoute };
  if (process.dev) {
    const backendUrl = config.public.backendUrl ?? "/";
    const pathPrefix = config.app.baseURL === "/" ? backendUrl : "";
    return navigateTo({ path: `${stripTrailingSlash(pathPrefix)}/signin`, query });
  } else {
    return safelyNavigateTo({ path: currentHost + "/signin", query }, { externalToThisApp: true });
  }
}
